var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0238037,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-0.042554 0 0.0238037)",
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1775_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4C9.375 4 4 9.375 4 16C4 22.625 9.375 28 16 28L23.1875 28C21.0625 29.25 18.625 30 16 30C8.25 30 2 23.6875 2 16C2 8.25 8.25 2 16 2C23.75 2 30 8.25 30 16C30 16.6875 29.9375 17.375 29.875 18L27.875 18C28 17.375 28.0625 16.6875 28.0625 16C28 9.375 22.625 4 16 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 24C27 24.6875 26.375 25.375 25.75 26L22.625 26L16 26C10.5 26 6 21.5 6 16C6 10.5 10.5 6 16 6C21.5 6 26 10.5 26 16C26 16.6875 25.9375 17.375 25.8125 18L23.75 18C23.9375 17.375 24 16.6875 24 16C24 11.5625 20.4375 8 16 8C11.5625 8 8 11.5625 8 16C8 20.4375 11.5625 24 16 24L22 24L24.9375 24L27.5 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.625 22C28.9375 21.375 29.1875 20.6875 29.375 20L27.25 20L25.125 20L22.875 20L20.4375 20L15.9375 20C13.75 20 11.9375 18.1875 11.9375 16C11.9375 13.8125 13.75 12 15.9375 12C18.125 12 19.9375 13.8125 19.9375 16C19.9375 16.75 19.75 17.4375 19.375 18L21.5625 18C21.8125 17.375 21.875 16.6875 21.875 16C21.875 12.6875 19.1875 10 15.875 10C12.5625 10 9.875 12.6875 9.875 16C9.875 19.3125 12.5625 22 15.875 22L21.1875 22L23.875 22L26.375 22L28.625 22Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1775_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndo);
export default __webpack_public_path__ + "static/media/ONDO.aa9650d8611ba2c1e281410b424b4200.svg";
export { ForwardRef as ReactComponent };